import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=72b05d3f"
import script from "./wait.vue?vue&type=script&lang=js"
export * from "./wait.vue?vue&type=script&lang=js"
import style0 from "./wait.vue?vue&type=style&index=0&id=72b05d3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports